import { Radio } from "antd";
import React from "react";
import "./RadioSelector.css";

const CustomRadio = ({ children, ...props }) => {
  return (
    <Radio className="custom-radio" {...props}>
      {children}
    </Radio>
  );
};

export default CustomRadio;